import { useQuery } from '@tanstack/react-query';
import { meetingApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Meeting minutes list for a job. */
export function useMeetings(jobId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.meetings.list(jobId ?? -1),
    queryFn: ({ signal }) =>
      meetingApiClient.getMeetings(jobId!, toCancelToken(signal)),
    enabled: jobId != null && jobId > 0,
    meta: { errorContext: 'meetings' },
  });
}
